export const RoutingPath = {
  /** テストページ */
  testPage: '/test-page',
  testDetail: '/test-detail',
  outPage: '/out-page',
  /** DataBase確認用 */
  callDB: '/call-db',

  /** ログイン */
  login: '/login',
  /** パスワード再発行画面 */
  sendPassword: '/password/send',
  /** パスワード再設定用メール送信完了 */
  sendPasswordComplete: '/password/send/complete',
  /** パスワード再設定画面 */
  changePassword: '/password/change',
  /** パスワード再設定エラー画面 */
  changePasswordError: '/password/change/error',
  /** パスワード再設定完了画面 */
  changePasswordComplete: '/password/change/complete',
  /** ユーザーアクティベート */
  userActivate: '/password/create',
  /** ユーザーアクティベートエラー画面 */
  userActivateError: '/password/create/error',
  /** ユーザーアクティベート完了画面 */
  userActivateComplete: '/password/create/complete',
  /** 顧客 */
  customer: '/customer',
  /** 顧客詳細 */
  customerDetail: '/customer/detail',
  /** 案件 */
  project: '/project',
  /** 案件詳細 */
  projectDetail: '/project/detail',
  /** 見積 */
  estimate: '/estimate',
  /** 見積詳細 */
  estimateDetail: '/estimate/detail',
  /** 受注 */
  order: '/order',
  /** メンテナンス */
  maintenance: '/maintenance',
  /** メンテナンス詳細 */
  maintenanceDetail: '/maintenance/detail',
  /** ファイル */
  file: '/file',
  /** ファイル詳細 */
  fileDetail: '/file/detail',
  /** 対応履歴 */
  supportHistory: '/support-history',
  /** 対応履歴詳細 */
  supportHistoryDetail: '/support-history/detail',
  /** CSV出力 */
  exportCsv: '/export-csv',
  /** マスタ管理 */
  master: '/master',
};
